export default __webpack_public_path__ + "static/media/checknewscreen-in.853dc8f6.jpg";